import styled from "styled-components";

export const Title = styled.h1`
  font-weight: normal;
  font-size: 34px;
  letter-spacing: 0.25px;
  margin-bottom: 40px;
`;

export const Subtitle = styled.h3`
  display: flex;
  flex-direction: row;
  justify-content: left;
  font-weight: medium;
  font-size: 20px;
  letter-spacing: 0.1px;
`;

export const Content = styled.p`
  display: flex;
  flex-direction: row;
  justify-content: left;
  font-weight: normal;
  font-size: 16px;
  letter-spacing: 0.25px;
`;
